// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import ReportCriteria from './report-criteria';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ReportResults from './report-results';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

class PIpHistoryReport extends Component {

    componentWillMount() {

        this.props.actions.getReportLayouts('pip-history');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();
            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetReport();
        this.props.actions.resetCriteria();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        return (
            <section className='pip-history-report'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='pip-history-report-title'>
                    <FormattedMessage id='PIP_HISTORY'/>
                    <FavoriteIcon
                        id='PIP_HISTORY'
                        route={this.props.pathName}
                    />
                </h2>
                <ReportCriteria/>
                <ReportResults/>
            </section>
        );

    }

}

PIpHistoryReport.displayName = 'PIpHistoryReport';
PIpHistoryReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(PipHistory)).isRequired,
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout)
};

export default PIpHistoryReport;



// WEBPACK FOOTER //
// ./src/reports/pip-history/components/index.js